export const dataAll = {
    us: [
        // 1.
        {
            productId: '15416991711305',
            variantId: '54815758483529',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FYCJXXC8?maas=maas_adg_2E89860C4146BB95543EDFBD5184FB3C_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-power-bank-built-in-usb-c-cable?variant=54815758483529',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932287156/1_white.png',
        },
        // 2.
        {
            productId: '15416991711305',
            variantId: '54815758450761',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FY6WBDMP?maas=maas_adg_7D52E855B4B31F0A254D5FD5A8AAECC8_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-power-bank-built-in-usb-c-cable?variant=54815758450761',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286102/1_black.png',
        },
        // 3.
        {
            productId: '15416992170057',
            variantId: '54815759892553',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FXX6NL3X?maas=maas_adg_4633CAF3FBD32DEFDC493C7C19A847AA_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-power-bank?variant=54815759892553',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286251/2_white.png',
        },
        // 4.
        {
            productId: '15416992170057',
            variantId: '54815759859785',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FXY1HXHZ?maas=maas_adg_1C3272642E5800DE035C2FD6ACA11F07_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-power-bank?variant=54815759859785',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286420/2_black.png',
        },
        // 5.
        {
            productId: '15361642856521',
            variantId: '54593882685513',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 6.
        {
            productId: '15361642856521',
            variantId: '54593882488905',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 7.
        {
            productId: '15361644593225',
            variantId: '54593884684361',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 8.
        {
            productId: '15361644593225',
            variantId: '54593884651593',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 9.
        {
            productId: '7302855557193',
            variantId: '41843266584649',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 10.
        {
            productId: '7302855557193',
            variantId: '54347781832777',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 11.
        {
            productId: '7302855557193',
            variantId: '42105281577033',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'lightblue',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 12.
        {
            productId: '7395983294537',
            variantId: '54612044054601',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // Accessory
        // 13.
        {
            productId: '15416976769097',
            variantId: '54815716507721',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FY6SWSHK?maas=maas_adg_E5BB45D9232D4516BAE087EA8572A1EA_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-wireless-charging-station-3-in-1-foldable?variant=54815716507721',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 14.
        {
            productId: '15416976769097',
            variantId: '54815716474953',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FYC96MRF?maas=maas_adg_24F7DA829F57EEB808F6498FF35A9D81_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-wireless-charging-station-3-in-1-foldable?variant=54815716474953',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
    ],
    ca: [
        // 1.
        {
            productId: '15219601539443',
            variantId: '62251972231539',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FYCJXXC8?maas=maas_adg_050EC1064EEE5789882942E271397446_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-power-bank-built-in-usb-c-cable?variant=62251972231539',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932287156/1_white.png',
        },
        // 2.
        {
            productId: '15219601539443',
            variantId: '62251972198771',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FY6WBDMP?maas=maas_adg_7A1D1B92750349906547DA0508788F80_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-power-bank-built-in-usb-c-cable?variant=62251972198771',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286102/1_black.png',
        },
        // 3.
        {
            productId: '15219601015155',
            variantId: '62251969380723',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FXX6NL3X?maas=maas_adg_A61C0CA01DD3A7F6CDEBBF5426C1EB1E_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-power-bank?variant=62251969380723',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286251/2_white.png',
        },
        // 4.
        {
            productId: '15219601015155',
            variantId: '62251969347955',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FXY1HXHZ?maas=maas_adg_3C11BCF5539B55095E377981C37DD7C3_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-power-bank?variant=62251969347955',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286420/2_black.png',
        },
        // 5.
        {
            productId: '15126377234803',
            variantId: '52731645493619',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 6.
        {
            productId: '15126377234803',
            variantId: '52731645460851',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 7.
        {
            productId: '15126380118387',
            variantId: '52731646509427',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 8.
        {
            productId: '15126380118387',
            variantId: '52731646476659',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 9.
        {
            productId: '8339992051866',
            variantId: '45181875421338',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 10.
        {
            productId: '15040389579123',
            variantId: '52359916388723',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 11.
        {
            productId: '15219601801587',
            variantId: '62251973378419',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FY6SWSHK?maas=maas_adg_324403D7B1CA9565BFD27D06C42FD6DC_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-wireless-charging-station-3-in-1-foldable?variant=62251973378419',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 12.
        {
            productId: '15219601801587',
            variantId: '62251973345651',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.ca/dp/B0FYC96MRF?maas=maas_adg_834E984785A834B2C07014E1C53E3CBE_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://ca.ecoflow.com/products/ecoflow-rapid-mag-wireless-charging-station-3-in-1-foldable?variant=62251973345651',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
    ],
    eu: [
        // 1.
        {
            productId: '10539681415511',
            variantId: '52711547076951',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932287156/1_white.png',
        },
        // 2.
        {
            productId: '10539681415511',
            variantId: '52711547109719',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286102/1_black.png',
        },
        // 3.
        {
            productId: '10559341298007',
            variantId: '52761883574615',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286251/2_white.png',
        },
        // 4.
        {
            productId: '10559341298007',
            variantId: '52761883607383',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286420/2_black.png',
        },
        // 5.
        {
            productId: '10057130049879',
            variantId: '50740963508567',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://eu.ecoflow.com/products/rapid-mag-power-bank-5k?variant=50740963508567',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 6.
        {
            productId: '10057130049879',
            variantId: '50740963475799',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://eu.ecoflow.com/products/rapid-mag-power-bank-5k?variant=50740963475799',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 7.
        {
            productId: '10057130639703',
            variantId: '50740965638487',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://eu.ecoflow.com/products/rapid-mag-power-bank-10k?variant=50740965638487',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 8.
        {
            productId: '10057130639703',
            variantId: '50740965605719',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://eu.ecoflow.com/products/rapid-mag-power-bank-10k?variant=50740965605719',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 9.
        {
            productId: '9604647747927',
            variantId: '49178411270487',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://eu.ecoflow.com/products/rapid-magnetic-power-bank?variant=49178411303255',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 10.
        {
            productId: '9604647747927',
            variantId: '49178411303255',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 11.
        {
            productId: '9604647747927',
            variantId: '49178411336023',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'lightblue',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 12.
        {
            productId: '9604647747927',
            variantId: '49178411368791',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 13.
        {
            productId: '9604647747927',
            variantId: '49178411401559',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // Accessory
        // 14.
        {
            productId: '10524713222487',
            variantId: '52667841315159',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 15.
        {
            productId: '10524713222487',
            variantId: '52667841347927',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 16.
        {
            productId: '10553790562647',
            variantId: '52747357159767',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Stand (3-in-1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
        // 17.
        {
            productId: '10553790562647',
            variantId: '52747357192535',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Stand (3-in-1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
    ],
    uk: [
        // 1.
        {
            productId: '10418180129107',
            variantId: '52981459222867',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932287156/1_white.png',
        },
        // 2.
        {
            productId: '10418180129107',
            variantId: '52981459255635',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NEW',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank (Built-in USB-C Cable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286102/1_black.png',
        },
        // 3.
        {
            productId: '10399201198419',
            variantId: '52908619399507',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286251/2_white.png',
        },
        // 4.
        {
            productId: '10399201198419',
            variantId: '52908619432275',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Power Bank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286420/2_black.png',
        },
        // 5.
        {
            productId: '9922548629843',
            variantId: '51053411139923',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://uk.ecoflow.com/products/rapid-mag-power-bank-5k?variant=51053411139923',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 6.
        {
            productId: '9922548629843',
            variantId: '51053411107155',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://uk.ecoflow.com/products/rapid-mag-power-bank-5k?variant=51053411107155',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 7.
        {
            productId: '9922552103251',
            variantId: '51053411893587',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://uk.ecoflow.com/products/rapid-mag-power-bank-10k?variant=51053411893587',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 8.
        {
            productId: '9922552103251',
            variantId: '51053411860819',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://uk.ecoflow.com/products/rapid-mag-power-bank-10k?variant=51053411860819',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 9.
        {
            productId: '9430789095763',
            variantId: '49700418093395',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://uk.ecoflow.com/products/rapid-magnetic-power-bank?variant=49700418027859',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 10.
        {
            productId: '9430789095763',
            variantId: '49700418027859',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 11.
        {
            productId: '9430789095763',
            variantId: '49700418060627',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'lightblue',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 12.
        {
            productId: '9430789095763',
            variantId: '49700418191699',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 13.
        {
            productId: '9430789095763',
            variantId: '49700418126163',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // Accessory
        // 14.
        {
            productId: '10418180096339',
            variantId: '52981459157331',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 15.
        {
            productId: '10418180096339',
            variantId: '52981459190099',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Stand (3-in-1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 16.
        {
            productId: '10418180161875',
            variantId: '52981459288403',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Stand (3-in-1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
        // 17.
        {
            productId: '10418180161875',
            variantId: '52981459321171',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEW',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Charging Station (3-in-1 Foldable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
    ],
    de: [
        // 1.
        {
            productId: '15793811784061',
            variantId: '57799311360381',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NEU',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Powerbank (Integriertes USB-C Kabel)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932287156/1_white.png',
        },
        // 2.
        {
            productId: '15793811784061',
            variantId: '57799311393149',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NEU',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Powerbank (Integriertes USB-C Kabel)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286102/1_black.png',
        },
        // 3.
        {
            productId: '15794386895229',
            variantId: '57801383772541',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NEU',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Powerbank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286251/2_white.png',
        },
        // 4.
        {
            productId: '15794386895229',
            variantId: '57801383805309',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NEU',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: 'https://www.amazon.com/dp/B0FXY1HXHZ?maas=maas_adg_1C3272642E5800DE035C2FD6ACA11F07_afap_abs&ref_=aa_maas&tag=maas',
                },
                {
                    type: 'learn',
                    link: 'https://us.ecoflow.com/products/ecoflow-rapid-mag-power-bank?variant=54815759859785',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Powerbank',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286420/2_black.png',
        },
        // 5.
        {
            productId: '15246676164989',
            variantId: '56082576474493',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://de.ecoflow.com/products/rapid-mag-power-bank-5k?variant=56082576474493',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 6.
        {
            productId: '15246676164989',
            variantId: '56082576441725',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://de.ecoflow.com/products/rapid-mag-power-bank-5k?variant=56082576441725',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 7.
        {
            productId: '15246676590973',
            variantId: '56082582077821',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://de.ecoflow.com/products/rapid-mag-power-bank-10k?variant=56082582077821',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 8.
        {
            productId: '15246676590973',
            variantId: '56082582045053',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://de.ecoflow.com/products/rapid-mag-power-bank-10k?variant=56082582045053',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 9.
        {
            productId: '9535539315023',
            variantId: '49966509588815',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://de.ecoflow.com/products/rapid-magnetic-power-bank?variant=49966509588815',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 10.
        {
            productId: '9535539315023',
            variantId: '49966509523279',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 11.
        {
            productId: '9535539315023',
            variantId: '49966509556047',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'lightblue',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 12.
        {
            productId: '9535539315023',
            variantId: '49966509687119',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 13.
        {
            productId: '9535539315023',
            variantId: '49966509621583',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // Accessory
        // 14.
        {
            productId: '15793811751293',
            variantId: '57799311294845',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEU',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Ladestation (3-in-1, faltbar)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 15.
        {
            productId: '15793811751293',
            variantId: '57799311327613',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEU',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Ladestation (3-in-1, faltbar)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
        // 16.
        {
            productId: '15793811816829',
            variantId: '57799311425917',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEU',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Ladestation (3-in-1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 17.
        {
            productId: '15793811816829',
            variantId: '57799311458685',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NEU',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'EcoFlow RAPID Mag Wireless Ladestation (3-in-1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
    ],
    fr: [
        // 1.
        {
            productId: '10330992214363',
            variantId: '52259122217307',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NOUVEAU',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Batterie externe EcoFlow RAPID Mag (câble USB-C intégré)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932287156/1_white.png',
        },
        // 2.
        {
            productId: '10330992214363',
            variantId: '52259122250075',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NOUVEAU',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Batterie externe EcoFlow RAPID Mag (câble USB-C intégré)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286102/1_black.png',
        },
        // 3.
        {
            productId: '10330992247131',
            variantId: '52259122282843',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NOUVEAU',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Batterie externe EcoFlow RAPID Mag',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286251/2_white.png',
        },
        // 4.
        {
            productId: '10330992247131',
            variantId: '52259122315611',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NOUVEAU',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Batterie externe EcoFlow RAPID Mag',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286420/2_black.png',
        },
        // 5.
        {
            productId: '9916300656987',
            variantId: '50630586237275',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://fr.ecoflow.com/products/rapid-mag-power-bank-5k?variant=50630586237275',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 6.
        {
            productId: '9916300656987',
            variantId: '50630586204507',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://fr.ecoflow.com/products/rapid-mag-power-bank-5k?variant=50630586204507',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 7.
        {
            productId: '9916300820827',
            variantId: '50630586696027',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://fr.ecoflow.com/products/rapid-mag-power-bank-10k?variant=50630586696027',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 8.
        {
            productId: '9916300820827',
            variantId: '50630586663259',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://fr.ecoflow.com/products/rapid-mag-power-bank-10k?variant=50630586663259',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 9.
        {
            productId: '9432019370331',
            variantId: '48933508219227',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://fr.ecoflow.com/products/rapid-magnetic-power-bank?variant=48933508219227',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 10.
        {
            productId: '9432019370331',
            variantId: '48933508251995',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 11.
        {
            productId: '9432019370331',
            variantId: '48933508284763',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'lightblue',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 12.
        {
            productId: '9432019370331',
            variantId: '48933508317531',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 13.
        {
            productId: '9432019370331',
            variantId: '48933508350299',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // Accessory
        // 14.
        {
            productId: '10353987879259',
            variantId: '52473963250011',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NOUVEAU',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Station de recharge sans fil EcoFlow RAPID Mag (3 en 1 pliable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 15.
        {
            productId: '10353987879259',
            variantId: '52473963282779',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NOUVEAU',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Station de recharge sans fil EcoFlow RAPID Mag (3 en 1 pliable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
        // 16.
        {
            productId: '10353960157531',
            variantId: '52473896960347',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NOUVEAU',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Support de recharge sans fil EcoFlow RAPID Mag (3 en 1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 17.
        {
            productId: '10353960157531',
            variantId: '52473896993115',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NOUVEAU',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Support de recharge sans fil EcoFlow RAPID Mag (3 en 1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
    ],
    it: [
        // 1.
        {
            productId: '15004745957752',
            variantId: '55448455283064',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NOVITÀ',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Power bank EcoFlow RAPID Mag (Cavo USB-C integrato)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932287156/1_white.png',
        },
        // 2.
        {
            productId: '15004745957752',
            variantId: '55448455315832',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NOVITÀ',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Power bank EcoFlow RAPID Mag (Cavo USB-C integrato)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286102/1_black.png',
        },
        // 3.
        {
            productId: '15004745990520',
            variantId: '55448455348600',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NOVITÀ',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Power bank EcoFlow RAPID Mag',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286251/2_white.png',
        },
        // 4.
        {
            productId: '15004745990520',
            variantId: '55448455381368',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NOVITÀ',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Power bank EcoFlow RAPID Mag',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286420/2_black.png',
        },
        // 5.
        {
            productId: '14929760649592',
            variantId: '55141750374776',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://it.ecoflow.com/products/rapid-mag-power-bank-5k?variant=55141750374776',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 6.
        {
            productId: '14929760649592',
            variantId: '55141750342008',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://it.ecoflow.com/products/rapid-mag-power-bank-5k?variant=55141750342008',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 7.
        {
            productId: '14929760682360',
            variantId: '55141752471928',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://it.ecoflow.com/products/rapid-mag-power-bank-10k?variant=55141752471928',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 8.
        {
            productId: '14929760682360',
            variantId: '55141752439160',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://it.ecoflow.com/products/rapid-mag-power-bank-10k?variant=55141752439160',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 9.
        {
            productId: '9760871121245',
            variantId: '54413549306205',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://it.ecoflow.com/products/rapid-magnetic-power-bank?variant=54413549306205',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 10.
        {
            productId: '9760871121245',
            variantId: '54413549240669',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 11.
        {
            productId: '9760871121245',
            variantId: '54413549273437',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'lightblue',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 12.
        {
            productId: '9760871121245',
            variantId: '54413549404509',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 13.
        {
            productId: '9760871121245',
            variantId: '54413549338973',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // Accessory
        // 14.
        {
            productId: '15009859961208',
            variantId: '55480040849784',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NOVITÀ',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Stazione di ricarica wireless EcoFlow RAPID Mag (pieghevole 3 in 1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 15.
        {
            productId: '15009859961208',
            variantId: '55480040882552',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NOVITÀ',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Stazione di ricarica wireless EcoFlow RAPID Mag (pieghevole 3 in 1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
        // 16.
        {
            productId: '15009846198648',
            variantId: '55479965516152',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NOVITÀ',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Base di ricarica wireless EcoFlow RAPID Mag (3 in 1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 17.
        {
            productId: '15009846198648',
            variantId: '55479965548920',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NOVITÀ',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Base di ricarica wireless EcoFlow RAPID Mag (3 in 1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
    ],
    es: [
        // 1.
        {
            productId: '10330994540891',
            variantId: '52259129393499',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NUEVO',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Banco de energía EcoFlow RAPID Mag (Cable USB-C incorporado)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932287156/1_white.png',
        },
        // 2.
        {
            productId: '10330994540891',
            variantId: '52259129426267',
            stageMapping: [[''], ['notify'], ['notify'], ['preorder'], ['preorder'], ['buy']],
            tag: 'NUEVO',
            spuKey: 'EcoFlow RAPID Mag Power Bank',
            allowLearnStage: 3,
            multiId: 30,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Banco de energía EcoFlow RAPID Mag (Cable USB-C incorporado)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286102/1_black.png',
        },
        // 3.
        {
            productId: '10330994573659',
            variantId: '52259129524571',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NUEVO',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Banco de energía EcoFlow RAPID Mag',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286251/2_white.png',
        },
        // 4.
        {
            productId: '10330994573659',
            variantId: '52259129557339',
            stageMapping: [[''], ['notify'], ['notify'], ['buy'], ['buy'], ['buy']],
            tag: 'NUEVO',
            spuKey: 'rapid_mag_510_10k',
            allowLearnStage: 3,
            multiId: 33,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Banco de energía EcoFlow RAPID Mag',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286420/2_black.png',
        },
        // 5.
        {
            productId: '9916312224091',
            variantId: '50630616318299',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://es.ecoflow.com/products/rapid-mag-power-bank-5k?variant=50630616318299',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 6.
        {
            productId: '9916312224091',
            variantId: '50630616285531',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_5k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://es.ecoflow.com/products/rapid-mag-power-bank-5k?variant=50630616285531',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 7.
        {
            productId: '9916312355163',
            variantId: '50630617661787',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://es.ecoflow.com/products/rapid-mag-power-bank-10k?variant=50630617661787',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 8.
        {
            productId: '9916312355163',
            variantId: '50630617629019',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'rapid_mag_504_10k',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://es.ecoflow.com/products/rapid-mag-power-bank-10k?variant=50630617629019',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 9.
        {
            productId: '9432041029979',
            variantId: '49343927157083',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: 'https://es.ecoflow.com/products/rapid-magnetic-power-bank?variant=49343927157083',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 10.
        {
            productId: '9432041029979',
            variantId: '49343927091547',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 11.
        {
            productId: '9432041029979',
            variantId: '49343927124315',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'EcoFlow RAPID Magnetic Power Bank 5000 02',
            allowLearnStage: 0,
            multiId: 16,
            color: 'lightblue',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 12.
        {
            productId: '9432041029979',
            variantId: '49343927255387',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // 13.
        {
            productId: '9432041029979',
            variantId: '49343927189851',
            stageMapping: [[''], ['buy'], ['buy'], ['buy'], ['buy'], ['buy']],
            tag: '',
            spuKey: 'product_rapid',
            allowLearnStage: 0,
            multiId: 16,
            color: 'sliver',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
        },
        // Accessory
        // 14.
        {
            productId: '10353989583195',
            variantId: '52473972392283',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NUEVO',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Estación de carga inalámbrica EcoFlow RAPID Mag (3 en 1 plegable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 15.
        {
            productId: '10353989583195',
            variantId: '52473972425051',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NUEVO',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Estación de carga inalámbrica EcoFlow RAPID Mag (3 en 1 plegable)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
        // 16.
        {
            productId: '10353968578907',
            variantId: '52473924485467',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NUEVO',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'white',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Soporte de carga inalámbrica EcoFlow RAPID Mag (3 en 1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
        },
        // 17.
        {
            productId: '10353968578907',
            variantId: '52473924518235',
            stageMapping: [[''], ['notify'], ['notify'], ['notify'], ['buy'], ['buy']],
            tag: 'NUEVO',
            spuKey: 'rapid_mag_pb020',
            allowLearnStage: 3,
            multiId: 32,
            color: 'black',
            btns: [
                {
                    type: 'notify',
                    link: '',
                },
                {
                    type: 'amazon',
                    link: '',
                },
                {
                    type: 'learn',
                    link: '',
                },
                {
                    type: 'buy',
                    link: '',
                },
                {
                    type: 'preorder',
                    link: '',
                },
            ],
            productTitle: 'Soporte de carga inalámbrica EcoFlow RAPID Mag (3 en 1)',
            variantImg: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
        },
    ],
};

export const dataInfo = {
    // us
    '15416991711305': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '36W', text: 'Built-in USB-C Cable' },
    ],
    '15416992170057': [
        { name: '15W Wireless Output', text: 'Qi2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: 'Multi angled', text: 'Foldable Kickstand' },
    ],
    '15361642856521': [
        { name: '5,000mAh', text: 'Massive Capacity ' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '15361644593225': [
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '7302855557193': [
        { name: '5,000mAh', text: 'Massive Capacity' },
        { name: '15W', text: 'Wireless Charging Output' },
    ],
    '7395983294537': [
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '15W', text: 'Wireless Charging Output' },
    ],
    '15416976769097': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: 'Foldable', text: '3-in-1 Design' },
        { name: 'For iPhone', text: 'Apple Watch, AirPods, and More' },
    ],

    // ca
    '15219601539443': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '36W', text: 'Built-in USB-C Cable' },
    ],
    '15219601015155': [
        { name: '15W Wireless Output', text: 'Qi2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: 'Multi angled', text: 'Foldable Kickstand' },
    ],
    '15126377234803': [
        { name: '5,000mAh', text: 'Massive Capacity ' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '15126380118387': [
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '8339992051866': [
        { name: '5,000mAh', text: 'Massive Capacity' },
        { name: '15W', text: 'Wireless Charging Output' },
    ],
    '15040389579123': [
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '15W', text: 'Wireless Charging Output' },
    ],
    '15219601801587': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: 'Foldable', text: '3-in-1 Design' },
        { name: 'For iPhone', text: 'Apple Watch, AirPods, and More' },
    ],

    // eu
    '10539681415511': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '36W', text: 'Built-in USB-C Cable' },
    ],
    '10559341298007': [
        { name: '15W Wireless Output', text: 'Qi2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: 'Multi angled', text: 'Foldable Kickstand' },
    ],
    '10057130049879': [
        { name: '5,000mAh', text: 'Massive Capacity ' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '10057130639703': [
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '9604647747927': [
        { name: '5,000mAh', text: 'Massive Capacity' },
        { name: '15W', text: 'Wireless Charging Output' },
    ],
    // '7395983294537': [
    //     { name: '10,000mAh', text: 'Massive Capacity' },
    //     { name: '15W', text: 'Wireless Charging Output' },
    // ],
    '10524713222487': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: 'Foldable', text: '3-in-1 Design' },
        { name: 'For iPhone', text: 'Apple Watch, AirPods, and More' },
    ],
    '10553790562647': [
        { name: '15W Wireless Output', text: 'Qi2 Certified' },
        { name: 'Internal', text: 'Cooling Fan' },
        { name: 'For iPhone', text: 'Apple Watch, AirPods, and More' },
    ],

    // uk
    '10418180129107': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '36W', text: 'Built-in USB-C Cable' },
    ],
    '10399201198419': [
        { name: '15W Wireless Output', text: 'Qi2 Certified' },
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: 'Multi angled', text: 'Foldable Kickstand' },
    ],
    '9922548629843': [
        { name: '5,000mAh', text: 'Massive Capacity ' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '9922552103251': [
        { name: '10,000mAh', text: 'Massive Capacity' },
        { name: '7.5W', text: 'Wireless Charging Output' },
    ],
    '9430789095763': [
        { name: '5,000mAh', text: 'Massive Capacity' },
        { name: '15W', text: 'Wireless Charging Output' },
    ],
    '10418180096339': [
        { name: '25W Wireless Output', text: 'Qi2.2 Certified' },
        { name: 'Foldable', text: '3-in-1 Design' },
        { name: 'For iPhone', text: 'Apple Watch, AirPods, and More' },
    ],
    '10418180161875': [
        { name: '15W Wireless Output', text: 'Qi2 Certified' },
        { name: 'Internal', text: 'Cooling Fan' },
        { name: 'For iPhone', text: 'Apple Watch, AirPods, and More' },
    ],

    // de
    '15793811784061': [
        { name: '25 W kabellose Ladeleistung', text: 'Qi2.2-zertifiziert' },
        { name: '10 000 mAh', text: 'hohe Kapazität' },
        { name: '36 W', text: 'integriertes USB-C Kabel' },
    ],
    '15794386895229': [
        { name: '15 W kabellose Ladeleistung', text: 'Qi2.2-zertifiziert' },
        { name: '10 000 mAh', text: 'hohe Kapazität' },
        { name: 'Mehrwinkeliger', text: 'klappbarer Ständer' },
    ],
    '15246676164989': [
        { name: '5 000 mAh', text: 'hohe Kapazität' },
        { name: '7,5 W', text: 'kabellose Ladeleistung' },
    ],
    '15246676590973': [
        { name: '10 000 mAh', text: 'hohe Kapazität' },
        { name: '7,5 W', text: 'Kabellose Ladeleistung' },
    ],
    '9535539315023': [
        { name: '5 000 mAh', text: 'hohe Kapazität' },
        { name: '15 W', text: 'Kabellose Ladeleistung' },
    ],
    '15793811751293': [
        { name: '25 W kabellose Ladeleistung', text: 'Qi2.2-zertifiziert' },
        { name: 'Faltbares', text: '3-in-1 Design' },
        { name: 'Für iPhone,', text: 'Apple Watch, AirPods und mehr' },
    ],
    '15793811816829': [
        { name: '15 W kabellose Ladeleistung', text: 'Qi2.2-zertifiziert' },
        { name: 'Interner', text: 'Kühllüfter' },
        { name: 'Für iPhone,', text: 'Apple Watch, AirPods und mehr' },
    ],

    // fr
    '10330992214363': [
        { name: 'Sortie sans fil 25 W', text: 'certifiée Qi2.2' },
        { name: '10 000 mAh', text: 'Capacité gigantesque de' },
        { name: '36 W', text: 'Câble USB-C intégré' },
    ],
    '10330992247131': [
        { name: 'Sortie sans fil 15 W', text: 'certifiée Qi2' },
        { name: '10 000 mAh', text: 'Capacité gigantesque de' },
        { name: 'Support pliable', text: 'orientable dans plusieurs directions' },
    ],
    '9916300656987': [
        { name: '5 000 mAh', text: 'Capacité gigantesque de' },
        { name: '7,5 W', text: 'Sortie de recharge sans fil' },
    ],
    '9916300820827': [
        { name: '10 000 mAh', text: 'Capacité gigantesque de' },
        { name: '7,5 W', text: 'Sortie de recharge sans fil' },
    ],
    '9432019370331': [
        { name: '5 000 mAh', text: 'Capacité gigantesque de' },
        { name: '15 W', text: 'Sortie de recharge sans fil' },
    ],
    '10353987879259': [
        { name: 'Sortie sans fil 25 W', text: 'certifiée Qi2.2' },
        { name: 'Conception', text: 'pliable 3 en 1' },
        { name: 'Pour iPhone', text: 'Apple Watch, AirPods et plus encore' },
    ],
    '10353960157531': [
        { name: 'Sortie sans fil 15 W', text: 'certifiée Qi2' },
        { name: 'Ventilateur de', text: 'refroidissement interne' },
        { name: 'Pour iPhone', text: 'Apple Watch, AirPods et plus encore' },
    ],

    // it
    '15004745957752': [
        { name: 'Uscita wireless da 25 W', text: 'Con certificazione Qi2.2' },
        { name: '10.000 mAh', text: 'Capacità elevata' },
        { name: '36 W', text: 'Cavo USB-C integrato' },
    ],
    '15004745990520': [
        { name: 'Uscita wireless da 15 W', text: 'Con certificazione Qi2' },
        { name: '10.000 mAh', text: 'Capacità elevata' },
        { name: 'Cavalletto pieghevole con', text: 'inclinazione regolabile' },
    ],
    '14929760649592': [
        { name: '5.000 mAh', text: 'Capacità elevata ' },
        { name: '7,5 W', text: 'Uscita di ricarica wireless' },
    ],
    '14929760682360': [
        { name: '10.000 mAh', text: 'Capacità elevata' },
        { name: '7,5 W', text: 'Uscita di ricarica wireless' },
    ],
    '9760871121245': [
        { name: '5.000 mAh', text: 'Capacità elevata' },
        { name: '15 W', text: 'Uscita di ricarica wireless' },
    ],
    '15009859961208': [
        { name: 'Uscita wireless da 25 W', text: 'Con certificazione Qi2.2' },
        { name: 'Design pieghevole', text: '3 in 1' },
        { name: 'Per iPhone', text: 'Apple Watch, AirPods e non solo' },
    ],
    '15009846198648': [
        { name: 'Uscita wireless da 15 W', text: 'Con certificazione Qi2' },
        { name: 'Ventola di', text: 'raffreddamento interna' },
        { name: 'Per iPhone', text: 'Apple Watch, AirPods e non solo' },
    ],

    // es
    '10330994540891': [
        { name: 'Salida inalámbrica de 25 W', text: 'Certificación Qi2.2' },
        { name: '10 000 mAh', text: 'Capacidad masiva' },
        { name: '36 W', text: 'Cable USB-C incorporado' },
    ],
    '10330994573659': [
        { name: 'Salida inalámbrica de 15 W', text: 'Certificación Qi2' },
        { name: '10 000 mAh', text: 'Capacidad masiva' },
        { name: 'Soporte plegable de', text: 'múltiples ángulos' },
    ],
    '9916312224091': [
        { name: '5000 mAh', text: 'Capacidad masiva ' },
        { name: '7,5 W', text: 'Salida de carga inalámbrica' },
    ],
    '9916312355163': [
        { name: '10 000 mAh', text: 'Capacidad masiva' },
        { name: '7,5 W', text: 'Salida de carga inalámbrica' },
    ],
    '9432041029979': [
        { name: '5000 mAh', text: 'Capacidad masiva' },
        { name: '15W', text: 'Salida de carga inalámbrica' },
    ],
    '10353989583195': [
        { name: 'Salida inalámbrica de 25 W', text: 'Certificación Qi2.2' },
        { name: 'Diseño', text: '3 en 1 plegable' },
        { name: 'Para iPhone', text: 'Apple Watch, AirPods y más' },
    ],
    '10353968578907': [
        { name: 'Salida inalámbrica de 15 W', text: 'Certificación Qi2' },
        { name: 'Ventilador de', text: 'refrigeración interno' },
        { name: 'Para iPhone', text: 'Apple Watch, AirPods y más' },
    ],
};
export const colorMapping: Record<string, string> = {
    white: '#ECECEC',
    black: '#3E3E3E',
    lightblue: '#c0defe',
};
